import { useGlobalStore } from "@/app/context/globalStoreProvider";
import { useMemo } from "react";
import { differenceInDays } from "date-fns";
const useStatusChallenge = () => {
  const { user, userCreditsData } = useGlobalStore();

  // states: Eligible /not eligible, inProgress, Complete
  const bookingsCount =
    userCreditsData?.userCredits?.userCreditsDetail?.gondolaBookingsCount;

  const statusChallengeComplete = useMemo(
    () =>
      (bookingsCount !== undefined && bookingsCount >= 3) ||
      (user?.data.gondolaGoldStartDate &&
        differenceInDays(new Date(), user.data.gondolaGoldStartDate) > 30),
    [bookingsCount, user?.data.gondolaGoldStartDate]
  );

  // we already gave these members Gondola Gold status
  const alreadyGoldMember =
    (user?.data.cashbackPercentage || 0) >= 0.05 &&
    !user?.data.gondolaGoldStartDate;

  const statusChallengeInProgress = useMemo(
    () =>
      user?.data.gondolaGoldStartDate &&
      differenceInDays(new Date(), user.data.gondolaGoldStartDate) <= 30 &&
      (bookingsCount === undefined || bookingsCount < 3),
    [user?.data.gondolaGoldStartDate, bookingsCount]
  );

  const statusChallengeEligible = useMemo(() => {
    return !alreadyGoldMember && !statusChallengeComplete;
  }, [alreadyGoldMember, statusChallengeComplete]);

  return {
    statusChallengeEligible,
    statusChallengeInProgress,
    statusChallengeComplete,
    bookingsCount,
  };
};

export default useStatusChallenge;
